<template>
  <div class="onboarding-form">
    <div class="tab-content">
      <div class="onboarding-tab active">
        <header>
          <h2>{{ __('Dokončení registrace') }}</h2>
        </header>

        <div class="tab-inputgroup">
          <div class="input-wrapper upload-photo">
          </div>

          <form-input-type-text
            name="name"
            :label="__('First name')"
            :errors="errors.name"
            margin-bottom-double
            required
          ></form-input-type-text>

          <form-input-type-text
            name="surname"
            :label="__('Last name')"
            :errors="errors.surname"
            margin-bottom-double
            required
          ></form-input-type-text>

          <form-input-type-email
            name="email"
            :label="__('E-mail')"
            :errors="errors.email"
            margin-bottom-double
            required
          ></form-input-type-email>

          <form-input-type-phone-number
            name="phone"
            :label="__('Phone number')"
            :errors="errors.phone"
            phoneCountry="CZ"
            margin-bottom-double
            required
          ></form-input-type-phone-number>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: {}
    }
  },
  mounted() {
    $('#register-form').animate({ opacity: 1 }, 300)
  },
  methods: {
    submit() {
      let data = new FormData(this.$el)

      axios
        .post('register', data)
        .then(() => window.location.replace('/'))
        .catch((e) => {
          this.errors = e.response.data.errors
        })
    }
  }
}
</script>
